import { sqLicenseManagementStore } from '@/core/core.stores';
import { useFluxPath } from '@/core/hooks/useFluxPath.hook';
import { Feature } from '@/licenseManagement/licenseManagement.store';
import { isLockingAndVersioningEnabled } from '@/services/systemConfiguration.utilities';

/**
 * Returns whether model locking is enabled — both the system configuration flag and the license feature must be active.
 * Uses useFluxPath so the component re-renders only when the license store's Locking feature validity changes.
 */
export function useLockingEnabled(): boolean {
  const hasLockingLicense = useFluxPath(sqLicenseManagementStore, (store) => store.hasValidFeature(Feature.Locking));
  return isLockingAndVersioningEnabled() && hasLockingLicense;
}
